import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'

@withRouter
export default class TextField extends React.Component {
  
  static propTypes = {
    fullWidth: PropTypes.bool,
    value : PropTypes.any,
    onChange : PropTypes.func,
    onBlur : PropTypes.func,
    timeoutBlur : PropTypes.bool,
    label : PropTypes.string,
    type : PropTypes.string,
    disabled : PropTypes.bool
  }

  static defaultProps = {
    fullWidth : true,
    timeoutBlur: false,
    disabled : false
  }

  constructor(props) {
    super(props)
    this.onBlur = this.onBlur.bind(this)
  }

  onBlur(event) {
    if (this.props.onBlur) {
      this.props.onBlur(event.target.value)
    }
    if (this.props.input) {
      this.props.input.onBlur(event.target.value)
    }
  }

  render() {
    let classes = [styles.TextField]
    if (this.props.fullWidth) {
      classes.push(styles.fullWidth)
    }
    const { meta } = this.props
    let errorText = null
    if (meta) {
      if (typeof meta.error === 'string') {
        classes.push(styles.error)
        errorText = meta.error
      }
    } else {
      errorText = this.props.errorText
    }
    return [
      <label key={0} className={styles.Label}>
        {this.props.label||''}
      </label>
      ,
      <div key={1}>
        <input 
          ref='theInput'
          className={classes.join(' ')}
          type={this.props.type || 'text'} 
          value={
            typeof this.props.value !== 'undefined' ? this.props.value 
                                                    : (this.props.input && this.props.input.value)
          }
          onBlur={this.onBlur}
          disabled={this.props.disabled}
          onChange={event => {
            if (this.props.onChange) {
              this.props.onChange(event.target.value)
            }
            if (this.props.input) {
              this.props.input.onChange(event.target.value)
            }

            var oldValue = event.target.value
            if (this.props.timeoutBlur) {
              setTimeout(() => {
                if (this.refs.theInput.value === oldValue) {
                  this.onBlur({ target : { value : oldValue } })
                }
              }, 400)
            }
          }}
          />
        { 
          errorText &&
            <div key={3} className={!this.props.smallErrors ? styles.ErrorText : styles.SmallErrorText}>{errorText}</div>
        }
      </div>
    ]
  }

}



// WEBPACK FOOTER //
// ./src/components/TextField/index.jsx